var _style, _path, _polyline, _line, _line2, _polyline2, _polyline3, _polyline4, _line3, _line4, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _rect2, _ellipse2, _rect3, _path15, _path16, _ellipse3, _rect4, _rect5, _line5, _line6, _line7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLenLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#000000;stroke-width:0.99;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#000000;stroke-width:0.99;stroke-miterlimit:10;stroke-dasharray:1.97,1.97;}\n\t.st4{fill:none;stroke:#000000;stroke-width:0.99;stroke-miterlimit:10;stroke-dasharray:1.95,1.95;}\n\t.st5{fill:#FFFFFF;stroke:#000000;stroke-width:0.56;stroke-miterlimit:10;}\n\t.st6{fill:#FFFFFF;stroke:#000000;stroke-width:0.28;stroke-miterlimit:10;stroke-dasharray:0.84;}\n\t.st7{fill:none;stroke:#000000;stroke-width:0.21;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#000000;stroke-width:0.21;stroke-miterlimit:10;stroke-dasharray:0.84,0.84;}\n\t.st9{fill:none;stroke:#000000;stroke-width:0.21;stroke-miterlimit:10;stroke-dasharray:0.83,0.83;}\n\t.st10{fill:#FFFFFF;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st11{fill:#FFFFFF;stroke:#010101;stroke-width:0.28;stroke-miterlimit:10;stroke-dasharray:0.75;}\n\t.st12{fill:#FFFFFF;stroke:#000000;stroke-width:1.09;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#000000;stroke-width:0.99;stroke-miterlimit:10;stroke-dasharray:1.97;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.1,179.9c-4.9,33.1-5.8,66.7-2.7,100l11.5,166.6l-63.4,2.1l-20.1,0.6l-20.1-0.6l-63.4-2.1l13.8-166.6 c3.1-33.3,2.2-66.9-2.7-100L134,153L75.7,275.8L45.5,259l69.6-158c5.4-12.3,16.7-21.1,30-23.4l45.3-7.7l21.1,0.7l21-0.7l45.3,7.7 c13.3,2.3,24.6,11.1,30,23.4l69.6,158l-27.9,15.6L289.1,153L285.1,179.9z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "281.4,303 290.3,443.9 210.3,446.5 130.3,443.9 141.6,303 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 281.4,
    y1: 303,
    x2: 281.4,
    y2: 304
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 281.6,
    y1: 305.9,
    x2: 290.2,
    y2: 441.9
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "290.2,442.9 290.3,443.9 289.3,443.9 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "287.4,444 210.3,446.5 132.3,444 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "131.3,443.9 130.3,443.9 130.4,442.9 "
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 130.6,
    y1: 440.9,
    x2: 141.4,
    y2: 305
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 141.5,
    y1: 304,
    x2: 141.6,
    y2: 303
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 207.4,
    y: 78.5,
    className: "st1",
    width: 10.7,
    height: 15.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.2,66.7v0.6c-0.5,1.1-1.2,2.1-1.9,3.1c-4.8,6.1-14.3,10.3-25.2,10.3l0,0c-0.5,0-1,0.1-1.5,0.3 c-10.3-0.4-19.2-4.4-23.8-10.2c-0.8-1-1.5-2.1-2-3.2l0,0c-0.1-0.1-0.1-0.3-0.2-0.4v-0.8c0.1,0.1,0-0.2,0,0v-0.1h0.1 c3.3-7.3,12.2-10.9,27-10.9C225.4,55.2,236.6,60.9,240.2,66.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M206.8,79.5L206.8,79.5c2.5,0,4.5,2,4.6,4.5l0,0l0.3,5.8c-0.2,0-4.7-0.2-4.9-0.3c-10.8-1.1-14.5-3.4-19.3-9.5 c-2-2.5-3.2-5.6-3.2-8.8v-10c0,0.3,0,0.5,0,0.8l0,0c0.1,1.7,0.5,3.3,1.2,4.8l0,0c0.5,1.1,1.2,2.2,2,3.2 C192.2,76.3,195.5,77.8,206.8,79.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.8,89l-3.9-0.2c-10.7-1.1-14.2-3.3-18.7-9.1c-1.9-2.3-3-5.3-3.1-8.3v-3.3c0.5,0.9,1.1,1.8,1.8,2.6 c4.9,6.2,8.4,7.9,19.8,9.6h0.2c2,0,3.7,1.7,3.7,3.7v0.1L210.8,89z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M218.6,79.6L218.6,79.6c-2.5,0-4.6,2-4.6,4.5v0l0,0l-0.3,5.8c0.2,0,4.7-0.2,4.9-0.3c10.8-1.1,14.5-3.4,19.3-9.5 c2-2.5,3.2-5.6,3.2-8.8v-10c0,0.3,0,0.5,0,0.8l0,0c-0.1,1.7-0.5,3.3-1.2,4.8l0,0c-0.5,1.2-1.2,2.2-2,3.2 C233.2,76.3,229.8,77.9,218.6,79.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.9,84.1L214.9,84.1c0-2,1.6-3.7,3.7-3.7h0.1c11.5-1.7,15-3.4,19.8-9.6c0.7-0.8,1.2-1.7,1.7-2.7v3.3 c0,3-1.1,6-3,8.3c-4.5,5.8-8,8.1-18.7,9.2l-3.9,0.2L214.9,84.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M241.2,61.1L241.2,61.1c-0.1,1.7-0.5,3.3-1.2,4.8l0,0V66c-3.6-5.8-14.4-10-27.2-10s-23.6,4.2-27.2,10l-0.1-0.1 l0,0c-0.7-1.5-1.1-3.1-1.2-4.8l0,0c0.6-7.6,13.1-13.6,28.4-13.6S240.5,53.5,241.2,61.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.7,64.3c-4.6-5.5-15.1-9.1-27-9.1s-22.4,3.6-27,9.1c-0.3-1-0.5-2.1-0.6-3.1c0.7-7.1,13-12.8,27.6-12.8 s26.9,5.7,27.6,12.8C240.2,62.2,240,63.2,239.7,64.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M239.8,63.9l-0.1,0.4l-0.3-0.3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M238.8,63.3c-4.9-5-14.9-8.2-26.1-8.2c-11.4,0-21.6,3.3-26.4,8.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M186,63.9l-0.3,0.3c0-0.1-0.1-0.3-0.1-0.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M185.4,63c-0.1-0.6-0.2-1.3-0.3-1.9c0.7-7.1,13-12.8,27.6-12.8s26.9,5.7,27.6,12.8c-0.1,0.8-0.2,1.6-0.4,2.3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M208,125v-0.8l0.2-33.3v-0.8c1.3,0.1,2.7,0.2,4,0.2h1.7c0.8,0,1.9,0,3.2-0.2v0.9l0.2,33.1v0.8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M208.8,124.2l0.2-33.1c1.2,0.1,2.2,0.1,2.9,0.1h1.5c0.7,0,1.6,0,2.9-0.1l0.2,33.1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.7,
    cy: 95.5,
    rx: 1.9,
    ry: 1.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 212.5,
    y: 93.1,
    width: 0.4,
    height: 5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.7,
    cy: 119,
    rx: 1.9,
    ry: 1.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 212.5,
    y: 116.5,
    width: 0.4,
    height: 5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M208,125.1v0.8l0.2,33.3v0.8c1.3-0.1,2.7-0.2,4-0.2h1.7c0.8,0,1.9,0.1,3.2,0.2v-0.9l0.2-33.1v-0.8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M208.8,125.9l0.2,33.1c1.2-0.1,2.2-0.1,2.9-0.1h1.5c0.7,0,1.6,0,2.9,0.1l0.2-33.1"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.9,
    cy: 142.1,
    rx: 1.9,
    ry: 1.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 212.7,
    y: 139.6,
    width: 0.4,
    height: 5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 231.6,
    y: 139.6,
    className: "st12",
    width: 36.5,
    height: 41.9
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 347.3,
    y1: 265.8,
    x2: 372.5,
    y2: 252.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 51.8,
    y1: 249.7,
    x2: 77.8,
    y2: 263.7
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 233.3,
    y1: 144.6,
    x2: 265.3,
    y2: 144.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLenLong);
export default __webpack_public_path__ + "static/media/len_long.013b000e96da33b01e3f3d4731a956be.svg";
export { ForwardRef as ReactComponent };